/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
/* eslint dot-notation: 0 */
/* eslint  no-param-reassign: 0 */
export const microbit_initial_block = (block, generator) => {
  let code = '';

  let branchDo = generator.statementToCode(block, 'DO');
  branchDo = branchDo.replace(/&quot;/g, '"');
  if (typeof block !== 'undefined' && block.id) {
    generator.setups_[block.id] = branchDo;
  }

  let branch = generator.statementToCode(block, 'REPEAT');
  branch = branch.replace(/&quot;/g, '"');

  code += `
led.enable(false)
basic.forever(function () {
  ${branch}
})
`;

  generator.loop_['forever'] = code;

  return '';
}

export const controls_if = (block, generator) => {
  let code = '';
  let argument = generator.valueToCode(block, 'IF0', generator.ORDER_NONE) || 'false';
  let branch = generator.statementToCode(block, 'DO0');
  code += `if (${argument}) {\n${branch}}`;

  for (let n = 1; n <= block.elseifCount_; n += 1) {
    argument = generator.valueToCode(block, `IF${n}`, generator.ORDER_NONE) || 'false';
    branch = generator.statementToCode(block, `DO${n}`);
    code += ` else if (${argument}) {\n${branch}}`;
  }

  if (block.elseCount_) {
    branch = generator.statementToCode(block, 'ELSE');
    code += ` else {\n${branch}}`;
  }

  return `${code}\n`;
}
